module.exports = __webpack_public_path__ + "img/showbill6.7345d7b9.jpg";